import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";

const EMPTY = { name: "", company: "", email: "", phone: "", address: "", notes: "", hide_signature: false };
const FIELDS = [["name", "Contact name *"], ["company", "Company"], ["email", "Email"], ["phone", "Phone"], ["address", "Billing address"]];

export const ClientDialog = ({ open, onOpenChange, initial, onSubmit }) => {
  const [form, setForm] = useState(EMPTY);
  useEffect(() => { if (open) setForm({ ...EMPTY, ...(initial || {}) }); }, [open, initial]);
  const submit = (e) => {
    e.preventDefault();
    onSubmit({ ...form, email: form.email || null });
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-slate-900 border-slate-700" data-testid="client-dialog">
        <DialogHeader><DialogTitle className="font-display">{initial?.id ? "Edit client" : "New client"}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          {FIELDS.map(([k, l]) => (
            <div key={k} className="space-y-1.5">
              <Label className="text-xs uppercase tracking-wider text-slate-400">{l}</Label>
              <Input data-testid={`client-input-${k}`} required={k === "name"} type={k === "email" ? "email" : "text"} value={form[k] || ""}
                onChange={(e) => setForm((f) => ({ ...f, [k]: e.target.value }))} className="bg-slate-950/60 border-slate-700" />
            </div>
          ))}
          <div className="space-y-1.5">
            <Label className="text-xs uppercase tracking-wider text-slate-400">Notes</Label>
            <Textarea data-testid="client-input-notes" value={form.notes || ""} onChange={(e) => setForm((f) => ({ ...f, notes: e.target.value }))} className="bg-slate-950/60 border-slate-700" />
          </div>
          <label className="flex items-start gap-3 text-sm text-slate-300 cursor-pointer">
            <Checkbox data-testid="client-hide-signature" checked={!!form.hide_signature} onCheckedChange={(v) => setForm((f) => ({ ...f, hide_signature: !!v }))} className="mt-0.5" />
            <span>Omit the analyst signature at the client's request<span className="block text-xs text-slate-500">Studies, letters and emails are signed with the company name only.</span></span>
          </label>
          <Button data-testid="client-save-btn" className="w-full rounded-full bg-emerald-500 text-emerald-950 hover:bg-emerald-400">Save client</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
